import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import RudiAdditionalDocNew from "../../components/services/additionalDoc/RudiAdditionalDocNew";

const RudiAdditionalDocNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <RudiAdditionalDocNew />
    </PageWrapper>
  );
};

export default RudiAdditionalDocNewPage;
